import { ReactNode } from "react";
import { OptionType } from "./types";

interface SelectFnBaseType {
  allSelected?: OptionType[];
  option: OptionType;
  onChange?: (values: OptionType[]) => void;
}
interface SelectFnType extends SelectFnBaseType {
  onSelect?: (option: OptionType) => void;
}
interface DeselectFnType extends SelectFnBaseType {
  isCategory?: boolean;
  onDeselect?: (option: OptionType) => void;
}

export function handleDeselect(props: DeselectFnType): OptionType[] | undefined {
  const { allSelected, option, isCategory, onChange, onDeselect } = props;
  let newOptions: OptionType[] | undefined;
  if (isCategory) {
    newOptions = allSelected?.filter((item) => !(item.type === "category" && item.value === option.value));
  } else {
    newOptions = allSelected?.filter((item) => !(item.value === option.value));
  }
  onChange?.(newOptions || []);
  onDeselect?.(option);
  return newOptions;
}

export function handleSelect(props: SelectFnType): OptionType[] {
  const { allSelected, option, onChange, onSelect } = props;
  const newOptions = [...(allSelected || []), option];
  onChange?.(newOptions || []);
  onSelect?.(option);
  return newOptions;
}

export function getOptionLabel(option: OptionType): string | ReactNode {
  return (
    option.label ||
    option.title ||
    (typeof option.value !== "object" ? option.value : (Object.values(option.value)[0] as string))
  );
}
